import React from "react";
import { SpinnerContainer, Spinner, SpinnerDot } from "./index.styled";

interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large";
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "medium",
  message = "טוען...",
}) => {
  return (
    <SpinnerContainer>
      <Spinner size={size}>
        <SpinnerDot key={0} $delay={0} />
        <SpinnerDot key={1} $delay={0.1} />
        <SpinnerDot key={2} $delay={0.2} />
      </Spinner>
      {message && <span>{message}</span>}
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
